<template>
  <div id="main-content">
    <div class="banner">
      <div class="tet-con">
        <h1 class="title">爱设计企业素材库</h1>
        <div class="desc">为创作者提供上亿级别高质量版权素材内容，可供在线设计制作。</div>
        <a href="/sucai.html" target="_blank" rel="noopener noreferrer" stats-mark="版权图片立即体验点击PV">
          <div class="act-btn-item act-btn-create">立即体验</div>
        </a>
        <img src="/new/image/team/banner_img.png" class="banner_img" alt="">
      </div>

    </div>

    <!-- 公司、团队、配额信息 -->
    <div class="message-summary" v-if="loginInfo && loginInfo.current_team_id && loginInfo.current_team_is_expired == 1">
      <div class="message-num"><img src="/new/image/team/xj_icon.png" alt=""
          srcset="">当前配额共{{ loginInfo.current_team_copyright_image }}张，剩余<span>{{ loginInfo.current_team_copyright_image_canuse }}</span>张
      </div>
      <div class="quota-btn" @click="$router.push('/user?info=auth')" v-if="loginInfo.current_team_role < 2">
        查看记录</div>
      <div class="upgrade-btn" @click="() => upgradedialogvisiable = true" v-if="loginInfo.current_team_role < 3">升级</div>
    </div>

    <div class="content-section">
      <div class="section-column-content-right">
        <h2 class="section-column-title section-column-text">精选高质量内容</h2>
        <div class="section-column-detail section-column-text">精选好图为优秀作品赋能，场景全覆盖。</div>
      </div>
      <div class="section-img-box">
        <img src="/new/image/team/img1.png" alt="">
      </div>
    </div>

    <div class="content-section">
      <div class="section-column-content-right">
        <h2 class="section-column-title section-column-text">商业授权<span>©️</span></h2>
        <div class="section-column-detail section-column-text">永久商业授权，商用无风险，永久使用。</div>
      </div>
      <div class="section-img-box ">
        <img src="/new/image/team/img2.png" alt="">
      </div>
    </div>

    <div class="content-section">
      <div class="section-column-content-right">
        <h2 class="section-column-title section-column-text">版权无忧</h2>
        <div class="section-column-detail section-column-text">提供单张商业授权书，商用版权无忧。</div>
      </div>
      <div class="section-img-box">
        <img src="/new/image/team/img3.png" alt="">
      </div>
    </div>
    <el-dialog
      :visible.sync="upgradedialogvisiable"
      title="升级后获取更多团队成员名额"
      class="level-dialog"
      width="525px"
    >
      <img
        src="../../../../assets/image/contact-us20220620.png"
        alt=""
        class="wx-img"
      />
      <p class="upgrade-text">微信扫码联系客服获得升级</p>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Copyright",
  data(){
    return {
      upgradedialogvisiable: false
    }
  },
  computed: {
    loginInfo() {
      return this.$store.getters.loginInfo;
    },
  }
};
</script>

<style scoped lang="scss">
#main-content {
  width: calc(100% - 200px);

  .banner {
    width: 100%;
    height: 420px;
    background: url("/new/image/team/banner.jpg") no-repeat center;
    background-size: cover;
    overflow: hidden;
    position: relative;
    margin-bottom: 60px;
    border-radius: 8px;

    .tet-con {
      position: absolute;
      width: 1085px;
      left: 50%;
      margin-left: -542.5px;
      top: 89px;

      .banner_img {
        width: 558px;
        height: 286px;
        position: absolute;
        top: -39px;
        right: -73px;
      }

      .title {
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0e0e0e;
        line-height: 50px;
      }

      .desc {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0e0e0e;
        line-height: 32px;
        margin-top: 20px;
      }

      .act-btn-item {
        margin-top: 38px;
        width: 128px;
        height: 40px;
        background: #0e0e0e;
        border-radius: 8px;
        opacity: 0.89;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
      }
    }
  }

  .message-summary {
    width: 1085px;
    height: 149px;
    margin: 60px auto 84px;
    background: #0e0e0e;
    box-shadow: 4px 4px 4px 0px rgba(245, 245, 245, 0.5);
    border-radius: 8px;
    position: relative;

    .message-num {
      position: absolute;
      top: 49px;
      left: 40px;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 42px;

      img {
        width: 40px;
        margin-right: 15px;
        vertical-align: -9px;
      }

      span {
        color: #eed599;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 42px;
      }
    }

    .quota-btn {
      position: absolute;
      top: 12px;
      right: 35px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffe4bb;
      line-height: 45px;
      cursor: pointer;
    }

    .upgrade-btn {
      position: absolute;
      right: 33px;
      bottom: 25px;
      width: 128px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #eed599;
      border-radius: 8px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #0e0e0e;
      cursor: pointer;
    }
  }

  .content-section {
    width: 1085px;
    margin: 0 auto 111px;
    position: relative;
    @include flex();

    .section-column-content-right {
      width: 266px;
      display: flex;
      flex: auto;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      .section-column-title {
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 33px;
        position: relative;

        span {
          display: block;
          position: absolute;
          right: -28%;
          top: -28%;
        }
      }

      .section-column-detail {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
        margin-top: 10px;
      }
    }

    .section-img-box {
      width: 696px;
      margin-left: 123px;

      img {
        width: 100%;
      }
    }

    .bos {
      img {
        width: 706px;
      }
    }
  }

  @media screen and (max-width: 1440px) {
    .banner {
      height: 287px;
      margin-bottom: 72px;

      .tet-con {
        position: absolute;
        width: 865px;
        margin-left: -433px;
        top: 70px;

        .banner_img {
          width: 397px;
          height: 204px;
          position: absolute;
          top: -31px;
          right: -50px;
        }

        .title {
          font-size: 24px;
          line-height: 33px;
        }

        .desc {
          font-size: 14px;
          line-height: 24px;
          margin-top: 12px;
        }

        .act-btn-item {
          margin-top: 29px;
          width: 110px;
          height: 36px;
          font-size: 14px;
          line-height: 36px;
        }
      }
    }

    .message-summary {
      width: 865px;
      margin-left: 123px;
    }

    .content-section {
      width: 865px;
      margin-left: 123px;
      margin-bottom: 67px;

      .section-column-content-right {
        .section-column-title {
          font-size: 20px;
          line-height: 28px;
        }

        .section-column-detail {
          font-size: 14px;
          line-height: 30px;
          margin-top: 6px;
        }
      }

      .section-img-box {
        width: 533px;
        margin-left: 56px;
      }

      .bos {
        img {
          width: 543px;
        }
      }
    }
  }

  @media screen and (max-width: 1280px) {
    .banner {
      min-width: 749px;
      height: 251px;
      margin-bottom: 62px;

      .tet-con {
        position: absolute;
        width: 749px;
        margin-left: -375px;
        top: 52px;

        .banner_img {
          width: 348px;
          height: 164px;
          position: absolute;
          top: -19px;
          right: -57px;
        }

        .title {
          font-size: 20px;
          line-height: 28px;
        }

        .desc {
          font-size: 12px;
          line-height: 20px;
          margin-top: 14px;
        }

        .act-btn-item {
          width: 100px;
          height: 32px;
          margin-top: 30px;
          font-size: 12px;
          line-height: 32px;
        }
      }
    }

    .message-summary {
      width: 749px;
      margin-left: 123px;
    }

    .content-section {
      width: 749px;
      margin-left: 123px;
      margin-bottom: 55px;

      .section-column-content-right {
        .section-column-title {
          font-size: 16px;
          line-height: 22px;
        }

        .section-column-detail {
          font-size: 12px;
        }
      }

      .section-img-box {
        width: 533px;
        margin-left: 56px;
      }

      .bos {
        img {
          width: 543px;
        }
      }
    }
  }
}
.level-dialog {
  @include flex(center,center);
  .wx-img {
    width: 164px;
    height: 164px;
    background: #aaaab1;
    margin: 24px auto 48px;
  }
  ::v-deep( .el-dialog__header) {
    height: 84px;
  }
  ::v-deep( .el-dialog) {
    height: 388px;
    font-weight: 400;
    color: #3c3c43;
    line-height: 20px;
    text-align: center;
    margin: 0!important;
  }
}
</style>
